var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0v100M0 50h100"
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5QbHVzPC90aXRsZT4KICAgIDxnIGlkPSJQbHVzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSI3IiBmaWxsPSJub25lIj4KICAgICAgICA8bGluZSB4MT0iNTAiIHgyPSI1MCIgeTE9IjAiIHkyPSIxMDAiIC8+CiAgICAgICAgPGxpbmUgeDE9IjAiIHgyPSIxMDAiIHkxPSI1MCIgeTI9IjUwIiAvPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgPlus as ReactComponent };